import { Helmet } from 'react-helmet';
import { DashboardData } from '../../components/DashboardData';
import { Title } from '../../components/Title';

export const Dashboard: React.FC = () => (
  <>
    <Helmet>
      <title>Bunzl | Dashboard</title>
    </Helmet>
    <Title title="Dashboard" />
    <DashboardData />
  </>
);
